export default __webpack_public_path__ + "static/media/image3.d45b67a2.png";